import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',

      '& > div + div': {
        marginTop: theme.spacing(2),
      },
    },
    container: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    row: {
      display: 'grid',
      gridTemplateColumns: 'minmax(250px, 1.5fr) repeat(3, 1fr)',
      width: '100%',
      height: 44,
      borderBottom: `1px solid ${theme.palette.grey[200]}`,
      padding: `0 ${theme.spacing(1)}px`,
      alignItems: 'center',
    },
    dayTitle: {
      fontWeight: 'bold',
      marginBottom: theme.spacing(0.5),
      padding: `0 ${theme.spacing(1)}px`,
    },
    headRow: {
      height: 36,
    },
    head: {
      fontWeight: 'bold',
      fontSize: theme.typography.pxToRem(12),
      display: 'flex',
      alignItems: 'center',
    },
  }),
);
